module.exports = __webpack_public_path__ + "img/logo-light.1cc2f08b.png";